import React from 'react';
import { FaQuoteRight } from 'react-icons/fa';

const DescriptionTab = ({ description }) => {
  if (!description) {
    return (
      <div className="text-center py-16 bg-[#F4F1EA] rounded-2xl border border-dashed border-[#D9D9D9]">
        <div className="w-16 h-16 mx-auto mb-4 rounded-full bg-[#F4F1EA] flex items-center justify-center">
          <svg className="w-8 h-8 text-[#79716B]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" />
          </svg>
        </div>
        <p className="text-[#79716B] font-medium">توضیحاتی برای این محصول ثبت نشده است</p>
        <p className="text-xs text-[#79716B]/60 mt-1">به زودی تکمیل خواهد شد</p>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h2 className="text-2xl font-bold text-[#292524]">توضیحات محصول</h2>
          <p className="text-sm text-[#79716B] mt-1">اطلاعات کامل درباره این محصول</p>
        </div>
        <FaQuoteRight className="w-6 h-6 text-[#9EAD8C]/30" />
      </div>

      <div className="relative p-6 bg-gradient-to-br from-[#FDFCFA] to-[#F4F1EA] rounded-2xl border border-[#D9D9D9]/50">
        <div className="absolute top-4 right-4 text-6xl opacity-5 text-[#9EAD8C]">
          <FaQuoteRight className="w-12 h-12" />
        </div>
        <div className="prose prose-sm max-w-none text-[#292524]/80 leading-relaxed text-justify">
          {description.split('\n\n').map((paragraph, index) => (
            <p key={index} className="mb-4 last:mb-0 text-sm leading-7">
              {paragraph}
            </p>
          ))}
        </div>
      </div>

      {/* برچسب‌های ویژگی */}
      <div className="flex flex-wrap gap-2">
        {['چوب طبیعی', 'کیفیت بالا', 'طراحی مدرن', 'مقاوم', 'دست‌ساز'].map((tag, index) => (
          <span
            key={index}
            className="px-3 py-1 bg-[#9EAD8C]/10 text-[#9EAD8C] rounded-full text-xs font-medium border border-[#9EAD8C]/20"
          >
            {tag}
          </span>
        ))}
      </div>
    </div>
  );
};

export default DescriptionTab;